import { ChangeDetectorRef, Component } from '@angular/core';
import {
    Animations,
    ElementSichtbarkeitEvent,
    ModalService,
    ProgressBarService,
    RateService,
    SidebarService,
    WiedereinsprungService,
    WiedereinsprungSpeichernResponse,
} from '@vhv/tarifrechner-common';
import { AppConfiguration } from '../app/app.configuration';
import { Router } from '@angular/router';
import { SidebarFunctionsBaugeraeteService } from '../service/sidebar-functions-baugeraete.service';

@Component({
    selector: 'baugeraete-header',
    templateUrl: 'baugeraete-header.component.html',
    animations: [Animations.scaleSlideAnimation],
    host: { 'class': 'navbar-wrapper' },
})
export class BaugeraeteHeaderComponent {

    public isPreisvorschlagHerunterladenButtonSichtbar: boolean;

    public isEingabenSichernButtonSichtbar: boolean;

    public isKontaktdatenButtonSichtbar: boolean;

    constructor(
        public readonly rateService: RateService,
        private readonly modalService: ModalService,
        private readonly progressBarService: ProgressBarService,
        private readonly conf: AppConfiguration,
        private readonly router: Router,
        private readonly preisvorschlagBaugeraeteService: SidebarFunctionsBaugeraeteService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly wiedereinsprungService: WiedereinsprungService,
        private readonly sidebarService: SidebarService
    ) {
        this.sidebarService.eingabenSichernButtonSichtbarkeitEvent.subscribe(
            (event: ElementSichtbarkeitEvent) => {
                this.isEingabenSichernButtonSichtbar = event.sollSichtbarSein;
                changeDetectorRef.detectChanges();
            },
        );

        this.sidebarService.preisvorschlagButtonSichtbarkeitEvent.subscribe(
            (event: ElementSichtbarkeitEvent) => {
                this.isPreisvorschlagHerunterladenButtonSichtbar = event.sollSichtbarSein;
                changeDetectorRef.detectChanges();
            },
        );

        this.sidebarService.standardKontaktdatenSichtbarkeitEvent.subscribe(
            (event: ElementSichtbarkeitEvent) => {
                this.isKontaktdatenButtonSichtbar = event.sollSichtbarSein;
                changeDetectorRef.detectChanges();
            },
        );

        this.sidebarService.vermittlerKontaktdatenAktualisiertEvent.subscribe(
            () => {
                this.isKontaktdatenButtonSichtbar = true;
            }
        );
    }

    public showSupport(): void {
        this.modalService.showPanel('contact', true);
    }

    public getProgress(): number {
        return this.progressBarService.progress;
    }

    public preisvorschlagHerunterladenClick() {
        this.preisvorschlagBaugeraeteService.preisvorschlagHerunterladen();
    }

    public eingabenSichernClick() {
        this.modalService.wiedereinsprungLinkEvent.next('');
        this.modalService.showPanel('wiedereinsprungErstellen', true);

        this.wiedereinsprungService
            .erstelleWiedereinsprungDaten()
            .then((response: WiedereinsprungSpeichernResponse) => {
                this.modalService.wiedereinsprungLinkEvent.next(response.wiedereinsprungUrl);
            });
    }

}
